module.exports = __webpack_public_path__ + "static/img/salesPlatform1.7a97c4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/salesPlatform1.png
// module id = PH3K
// module chunks = 1